<script lang="ts">
    /**
     * Wrapper component for FavoriteButton to handle any style overrides and centralize boilerplate
     * code for favortie button usage in the various players.  Currently exposed in:
     * - Chrome player LCD (Desktop)
     * - Full screen players (all viewports)
     * - Full screen player queue/info panels (mobile viewports)
     */

    // Types
    import { makeUserComponentsAction } from '@jet-app/music-classical/action-model/UserComponentsAction';

    // Component
    import FavoriteButton from '~/components/jet/buttons/FavoriteButton.svelte';

    // Utils
    import { getJetPerform } from '~/jet';
    import { getLocale } from '~/utils/locale';
    import { toggleFavorite } from '~/utils/favorites';

    // Stores
    import {
        subscribeToId,
        type LibraryStateValue,
    } from '~/stores/local-library-state';

    const perform = getJetPerform();
    const locale = getLocale();

    export let id: string;
    export let platter: boolean = true;

    $: storefront = locale.storefront;

    let libraryState: LibraryStateValue;

    $: {
        subscribeToId(id, (value) => {
            libraryState = value;
        });
    }

    function handleToggleFavorite() {
        toggleFavorite(
            id,
            libraryState?.type,
            storefront,
            libraryState.inFavorites,
            perform,
        );
    }
</script>

<div class="metadata-favorite-button" data-testid="metadata-favorite-button">
    {#if libraryState}
        <FavoriteButton
            on:toggle={handleToggleFavorite}
            isFavorited={libraryState.inFavorites}
            {platter}
        />
    {/if}
</div>
